import { useTranslation } from "react-i18next";
import FAQSection from "../organisms/sections/faq/FAQSection";
import Content from "../templates/wrapper/Content";
import { getFaqData } from "../../helpers/faq";

const FAQ = () => {
  const { t } = useTranslation();
  const data = getFaqData(t);

  return (
    <>
      <Content>
        <FAQSection items={data} />
      </Content>
    </>
  );
};

export default FAQ;
